import loadable from '@loadable/component';
import Skeleton from '../components/Reusable/Skeleton';
import APIS from '../constant/Endpoint';
import useGetHook from '../customHooks/useGetHook';
import usePostHook from '../customHooks/usePostHook';
import { queryClient } from '../router';
const DashboardComponent = loadable(() => import('../components/Dashboard'));

const OverView = () => {
  const { data: currentUserProfile, isLoading: isCurrentUserProfileLoading } =
    useGetHook({
      queryKey: ['current-user-profile'],
      url: `${APIS.STAFF}me/`,
      params: {},
    });

  const { data: clientType, isLoading: isClientTypeLoading } = useGetHook({
    queryKey: ['client-type'],
    url: `${APIS.CLIENT_TYPE}`,
    params: {},
  });

  const {
    data: gridData,
    isLoading,
    refetch,
  } = useGetHook({
    queryKey: [`grid-data`],
    url: `${APIS.GRID_REPORT_DATA}`,
    params: {
      parent__slug: 'overview',
    },
  });

  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: ['cache-clear'],
  });

  const handleClearCache = async () => {
    const url = `${APIS.CACHE}`;
    const formData = {
      name: 'overview',
    };
    try {
      const res = await mutateAsync({ url, formData });
      if (res?.status === 200) {
        refetch();
        const queriesToInvalidate = ['overview', 'payment-method'];
        queriesToInvalidate.forEach((key) => {
          queryClient.invalidateQueries({
            queryKey: [key],
            refetchType: 'active',
          });
        });
      }
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <>
      {isCurrentUserProfileLoading || isLoading || isClientTypeLoading ? (
        <Skeleton />
      ) : (
        <DashboardComponent
          currentUserProfile={currentUserProfile}
          gridData={gridData}
          handleClearCache={handleClearCache}
          isLoading={isPostLoading}
          clientType={clientType}
        />
      )}
    </>
  );
};

export default OverView;
